import { PrintCardContentViewModel } from '../shared/print-card-content-view-model';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { VariantType } from '../../../../../../models/enum/dto/variant-type.enum';
import { Injectable } from '@angular/core';
import { SortUtils } from '../../../../../../utils/sort-utils';
import { PrimaryCannabinoid } from '../../../../../../models/enum/shared/cannabinoid';
import type { PropertyPoolSorter } from '../shared/card-data-with-property-pooling';

@Injectable()
export abstract class OGKushPrintCardContentViewModel extends PrintCardContentViewModel {
  private readonly pinnedSecondaryPropertyMap = new Map<string, number>([
    [PrimaryCannabinoid.THC, 0],
    [PrimaryCannabinoid.CBD, 1]
  ]);

  public hideRightSideOfCard$ = combineLatest([
    this.badgeOrLabelVisible$,
    this.isNonCannabinoidVariant$,
    this.cardStack$
  ]).pipe(
    map(([badgeOrLabelVisible, isNonCannabinoidVariant, cardStack]) => {
      const gridMode = cardStack?.isGridMode();
      return !gridMode && isNonCannabinoidVariant && !badgeOrLabelVisible;
    })
  );

  public showVariantType$ = combineLatest([this.cardData$, this.cardStack$]).pipe(
    map(([cardData, cardStack]) => {
      const gridMode = cardStack?.isGridMode();
      const isCapsule = cardData?.rowVariantType() === VariantType.Capsule;
      return gridMode || !isCapsule;
    })
  );

  public readonly propertiesToDisplay$ = this.propertiesBasedOnPools$;

  public readonly gridPropertiesBasedOnPools$ = this.getGridPropertiesBasedOnPools$(this.spoofedGridColViewModels$);

  protected override emptyPropertyValueForPropertiesBasedOnPools(): string {
    return '-';
  }

  protected override getSecondaryPoolOfCompoundPropertiesSortLambda(): PropertyPoolSorter {
    const defaultSort = super.getSecondaryPoolOfCompoundPropertiesSortLambda();
    return (a, b) => {
      return SortUtils.pinned(this.pinnedSecondaryPropertyMap, a?.title, b?.title) || defaultSort(a, b);
    };
  }
}
